import { createApiQueryHook, IApiQueryFunction, IPaginateable, mapPagination } from "../../utils/api";
import { serialize } from "../../utils/url";
import { IMediaList } from "../types";

export type IMediaSecuredListQueryParameters = IPaginateable;

export type IMediaSecuredListQueryResult = IMediaList;

export const mediaSecuredListQuery: IApiQueryFunction<IMediaSecuredListQueryParameters> = ({ pagination }) => {
    return {
        method: "GET",
        url: `/media_secureds${serialize(
            {
                ...mapPagination(pagination),
            },
            true,
        )}`,
    };
};

export const useMediaSecuredListQuery = createApiQueryHook<
    IMediaSecuredListQueryParameters,
    IMediaSecuredListQueryResult
>(mediaSecuredListQuery);
